import { captureException } from '@sentry/react'
import { type UseQueryOptions, useQuery } from '@tanstack/react-query'
import {
	HttpGetReasonsDeclineResponse,
	httpGetReasonsDecline
} from '@/features/photoset/http/photoset.http'
import { parseAxiosPromise } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useGetReasonsDecline = (
	options?: Omit<
		UseQueryOptions<HttpGetReasonsDeclineResponse>,
		'queryFn' | 'queryKey'
	>
) =>
	useQuery({
		...options,
		queryKey: [QUERY_KEYS.REASONS_DECLINE],
		queryFn: () =>
			parseAxiosPromise({
				axiosPromise: httpGetReasonsDecline(),
				responseShape: HttpGetReasonsDeclineResponse,
				onZodError: captureException
			})
	})
